import React, { useState } from 'react';
import { Link, Outlet, useLocation, Navigate } from 'react-router-dom';

const Security = () => {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  // If we're at the root security path, redirect to users tab
  if (location.pathname === '/security') {
    return <Navigate to="/security/users" replace />;
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      <div className="sm:flex sm:items-center mb-8">
        <div className="sm:flex-auto">
          <h1 className="text-xl font-semibold text-gray-900">Security</h1>
          <p className="mt-2 text-sm text-gray-700">
            Manage users and access controls for the application.
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200 mb-8">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          <Link
            to="/security/users"
            className={`${
              isActive('/security/users')
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            Users
          </Link>
          <Link
            to="/security/roles"
            className={`${
              isActive('/security/roles')
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            Roles
          </Link>
          <Link
            to="/security/permissions"
            className={`${
              isActive('/security/permissions')
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
          >
            Permissions
          </Link>
          {/* Add more tabs here as needed */}
        </nav>
      </div>

      {/* Tab content */}
      <div>
        <Outlet />
      </div>
    </div>
  );
};

export default Security; 